export const getTemplateTitle = (formData: Record<string, any> = {}) => {
    const { company, subtypeSelectOption, subtypeClassification } = formData;
    const subtype = subtypeSelectOption || (subtypeClassification && subtypeClassification.type ? subtypeClassification.type : 'General presentation');
    return `${company || 'ACME'} | ${subtype}`;
}